<section>
    <div>
        <form [formGroup]="updateClient">
            <div class="form-group">
                <label for="uc-first-name">First Name</label>
                <input id="uc-first-name" formControlName="first_name" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="uc-last-name">Last Name</label>
                <input id="uc-last-name" formControlName="last_name" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="uc-phone">Phone Number</label>
                <input id="uc-phone" formControlName="phone_number" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="uc-city">City</label>
                <input id="uc-city" formControlName="city" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="uc-address">Address</label>
                <input id="uc-address" formControlName="address" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label for="uc-governorate">Governorate</label>
                <input id="uc-governorate" formControlName="governorate" type="text" class="form-control">
            </div>
            <button (click)="onNoClick()" class="btn">Save</button>
        </form>
    </div>
</section>
